export default function InformationSection({ title = null, children }) {
    return (
        <div className={`information-section`}>
            { title && <p className="information-section__title">{ title }</p> }
            { children }
        </div>
    )
}